import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type DeetsMultiSelectInput_query$key } from '@/__generated__/DeetsMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'
import { PROFILE_DEET_OTHER_MAX } from '@/lib'

export type DeetsMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: DeetsMultiSelectInput_query$key | null | undefined
}

export const DeetsMultiSelectInput = forwardRef<MultiSelectInputRef, DeetsMultiSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment DeetsMultiSelectInput_query on Query {
          deets(orderBy: [SEQUENCE_ASC]) {
            nodes {
              isOther
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <MultiSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.deets?.nodes, (deet) => ({
              isOther: deet!.isOther,
              label: deet!.name,
              value: deet!.rowId
            })),
          [queryData?.deets?.nodes]
        )}
        otherMaxLength={PROFILE_DEET_OTHER_MAX}
        ref={ref}
        {...props}
      />
    )
  }
)

DeetsMultiSelectInput.displayName = 'DeetsMultiSelectInput'
